import * as React from "react";
import { TextBox } from "../../forms/informedv4/TextBoxV4";
import { Required } from "../../forms/validation/Required";
import { useFormApi } from "informedv4";

export interface ReportsAdministationFormProps {
    handleSubmit: (form) => void;
    isConnected?: boolean;
    defaultServerURL: string;
    defaultUsername: string;
}

export const ReportsAdministrationForm = (props: ReportsAdministationFormProps) => {
    const [submitting, setSubmitting] = React.useState(false);
    const formApi = useFormApi();

    const onSubmit = () => {
        setSubmitting(true);
        formApi.validate();

        const state = formApi.getFormState();

        if (state.invalid) {
            setSubmitting(false);
            return;
        }

        props.handleSubmit(state.values);
        setSubmitting(false);
    }

    return (
        <>
            <div className="row">
                <div className="form-group">
                    <div className="col-sm-4">
                        <label htmlFor="ServerURL" className="pull-right">Report Server Location</label>
                    </div>
                    <div className="col-sm-8">
                        <div>The URL of the report server to connect to</div>
                        <TextBox name="ServerURL" initialValue={props.defaultServerURL} defaultValue={props.isConnected ? props.defaultServerURL : null} field="ServerURL" id="ServerURL" validate={Required} className="form-control" disabled />
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-4">
                        <label htmlFor="Username" className="pull-right">Username</label>
                    </div>
                    <div className="col-sm-8">
                        <div>the generic user account that the Web Portal should use to connect to the Report Server</div>
                        <TextBox name="Username" initialValue={props.defaultUsername} defaultValue={props.defaultUsername} id="Username" field="Username" validate={Required} className="form-control" disabled/>
                    </div>
                </div>
            </div>
        </>
    );
}
